const userAgent = navigator.userAgent
export const isAdsenseBot = userAgent?.includes('Mediapartners-Google') || userAgent?.includes('Google-Display-Ads-Bot')
